import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModules } from 'src/app/shared.modules';
import { DialogRegistrationCompleteComponent } from './dialog-registration-complete.component';

@NgModule({
    declarations: [DialogRegistrationCompleteComponent],
    imports: [
        CommonModule,
        SharedModules
    ]
})
export class DialogRegistrationCompleteModule { }
